module.exports = __webpack_public_path__ + "img/125-276a5f.png";